import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import Menu from "../../Components/Menu";

import Section1_Header from "./S1_Header";
import S2_Findus from "./S2_Links";
import S3_About from "./S3_About";
import S4_Mars from "./S4_Mars";
import S5_Toko from "./S5_Toko";
import S6_Footer from "./S6_Footer";

import { PageWrapper } from "../../Styles/style";




const MainPage = (props) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <>
      <PageWrapper  style={{overflow: "hidden"}}>
          <Menu/>
          <Section1_Header />
          <S2_Findus />
          <S3_About />
          <S4_Mars />
          <S5_Toko />
          <S6_Footer />
      </PageWrapper>
    </>
  );
};

export default MainPage;
